module.exports = __webpack_public_path__ + "img/person.14b521e6.svg";